import { render, staticRenderFns } from "./MailSegnalazioniConfiguration.vue?vue&type=template&id=93ec4842"
import script from "./MailSegnalazioniConfiguration.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioniConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports